import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getReviews, resetReviews } from '../../actions/adminReviews';
import Spinner from '../Spinner';

const PendingReviews = ({ adminReviews, getReviews, resetReviews }: any) => {
  const history = useHistory();

  useEffect(() => {
    getReviews(1);
    return () => { resetReviews(); };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const pending = adminReviews.reviews.filter((r: any) => !r.isActive);

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <p className="admin-card-title">Pending Reviews</p>
        {pending.length > 0 && (
          <span className="admin-badge">{pending.length}</span>
        )}
      </div>
      <div className="admin-card-body admin-card-body-flush">
        {adminReviews.loading && (
          <div className="text-center py-4">
            <Spinner />
          </div>
        )}

        {!adminReviews.loading && pending.length === 0 && (
          <div className="admin-empty-state">
            <i className="far fa-comment-dots" />
            <p>All reviews are published</p>
          </div>
        )}

        {pending.length > 0 && (
          <ul className="pending-reviews-list">
            {pending.slice(0, 5).map((review: any) => (
              <li key={review._id} className="pending-review-item">
                <div className="pending-review-stars">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={i < Math.ceil(review.rating) ? 'fas fa-star' : 'far fa-star'}
                      style={{ color: '#f59e0b', fontSize: '0.65rem' }}
                    />
                  ))}
                </div>
                <p className="pending-review-text">{review.review}</p>
                <p className="pending-review-meta">
                  {review.firstName} on <span>{review.product?.name}</span>
                </p>
              </li>
            ))}
            {pending.length > 5 && (
              <li className="pending-review-more" onClick={() => history.push('/adminpanel/reviews')}>
                +{pending.length - 5} more — view all
              </li>
            )}
          </ul>
        )}

        {pending.length > 0 && (
          <div className="pending-reviews-footer">
            <button
              className="admin-link-btn"
              onClick={() => history.push('/adminpanel/reviews')}
            >
              Manage reviews <i className="fas fa-arrow-right ml-1" style={{ fontSize: '0.7rem' }} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  adminReviews: state.adminReviews,
});

export default connect(mapStateToProps, { getReviews, resetReviews })(PendingReviews);
